import "./aboutUsNew.css";
import { CompanyProfile,  Leadership, Team } from "../../Components/About US";
import {teamData, leadersData} from './data'

const AboutUs = () => {
  return (
    <>
      {/* Indranil: 25Aug26: Removed 'home' class changed CSS class 'bg-aboutus' to 'bg-aboutusnew'  */}
      {/* <div className="home bg-aboutus"> */}
      <div className="bg-aboutusnew">
        {/*<h1 className="hero-title-about-us" >About Us</h1>*/}
      </div>
      <CompanyProfile/>
      {/* <Leadership title={'Leadership'} data={leadersData} /> */}
      {/* <Team title={'Team'} data={teamData} abtUs /> */}
      
    </>
  );
};

export default AboutUs;
